import { TOKEN, ORG_STATUS } from "src/helpers/constant";
import storage from "src/services/storage";
import { store } from "src/store";
import {
  getCurrentPlanDetail,
  getCurrentTimeTrial,
  getUserLoggedApi,
  loginAsOrganizationAdminApi,
} from "src/services/api";
import router from "@/router/index";
import { checkPermissionPlanFunction } from "src/helpers/functions";
import i18n from "src/services/i18n";

export function auth(to, from, next) {
  if (document.referrer === process.env.VUE_APP_SYS_SITE) {
    storage.set(TOKEN, "sys_token");
  }
  const token = storage.get("token");
  token ? next() : next({ name: "Login" });
}

export async function guest(to, from, next) {
  if (document.referrer === process.env.VUE_APP_SYS_SITE) {
    storage.get(TOKEN) ? next({ name: "Home" }) : next();
  }
}

function hasPermission(permissionCode, permissions) {
  if (!permissionCode || !permissions) {
    return true;
  }

  const isDeniedPermission = (value) => value === false || value === 0 || value === "0";

  // Simple string code
  if (typeof permissionCode === "string") {
    const value = permissions[permissionCode];
    return !isDeniedPermission(value);
  }

  const { parent, code } = permissionCode;
  if (parent && isDeniedPermission(permissions[parent])) {
    return false;
  }

  if (parent && code && permissions[parent] && typeof permissions[parent] === "object") {
    const childValue = permissions[parent][code];
    if (isDeniedPermission(childValue)) {
      return false;
    }
  }

  return true;
}

export async function checkPermission403(to, from, next) {
  try {
    let userInfo = store.state.user.userInfo;
    if (!userInfo) {
      const res = await getUserLoggedApi(true);
      if (res.status === 200) {
        store.commit("user/updateUser", res.data);
        userInfo = res.data;
      }
    }

    const permissionCode = to.meta?.permissionCode;
    if (!permissionCode) {
      return next();
    }

    const permissions = userInfo?.permission;
    if (!hasPermission(permissionCode, permissions)) {
      router.app?.$toasted?.error(i18n.t("no_permission"), {
        position: "bottom-right",
        duration: 3000,
      });
      return next({ name: "Home" });
    }

    return next();
  } catch (err) {
    console.error("checkPermission403 error:", err);
    return next({ name: "Home" });
  }
}

export async function checkOwner(to, from, next) {
  try {
    let userInfo = store.state.user.userInfo;
    if (!userInfo) {
      const res = await getUserLoggedApi(true);
      if (res.status === 200) {
        store.commit("user/updateUser", res.data);
        userInfo = res.data;
      }
    }

    if (userInfo?.is_owner) {
      return next();
    }

    router.app?.$toasted?.error(i18n.t("no_permission"), {
      position: "bottom-right",
      duration: 3000,
    });
    return next({ name: "Home" });
  } catch (err) {
    console.error("checkOwner error:", err);
    return next({ name: "Home" });
  }
}

// export async function trialPeriod(to, from, next) {
//   if (!store.state.plans.initial) {
//     store.commit(
//       "plans/updateInitial",
//       getCurrentPlanDetail().then(async (res) => {
//         if (res.status !== 200) {
//           await store.commit("plans/updateInitial", null);
//           return;
//         }
//         const { plan } = res.data;
//         if (!plan.is_default) {
//           await store.commit("plans/updatePlan", plan);
//         } else {
//           await store.commit("plans/updatePlan", plan);
//           await store.commit("trial/setIsTrial", true);
//           await store.commit("trial/setNextRequest", false);
//           await store.commit("trial/setTrialExpiration", 0);
//           await store.commit("trial/setEndTimeTrial", 0);
//         }

//         if (plan && plan.is_trial) {
//           await store.commit("trial/setIsTrial", plan.is_trial);
//           await store.commit("trial/setTrialId", plan.trial_id);

//           const resTrial = await getCurrentTimeTrial(plan.trial_id);
//           if (resTrial.status === 200) {
//             const trial = resTrial.data;
//             const endTimeTrial = trial.endTimeTrial;
//             const trialExpiration = trial.trialExpiration;

//             await store.commit("trial/setTrialExpiration", trialExpiration);
//             await store.commit("trial/setEndTimeTrial", endTimeTrial);
//             await store.commit("trial/setNextRequest", trialExpiration > 0);
//           }
//         }
//       })
//     );
//   }

//   Promise.resolve(store.state.plans.initial).then(() => {
//     if (
//       !store.state.plans.plan ||
//       store.state.plans.plan.is_default ||
//       store.state.plans.plan.is_expired
//     ) {
//       if (to.name !== "PlanChange") {
//         next({ name: "PlanChange" });
//       }
//     } else if (
//       store.state.plans.plan &&
//       (!store.state.trial.isTrial || to.name === "PlanChange")
//     ) {
//       next();
//     } else {
//       store.state.trial.nextRequest ? next() : next({ name: "Home" });
//     }
//   });
// }

export async function trialPeriod(to, from, next) {
  // console.log("Checking trial...");
  try {
    if (!store.state.plans.initial) {
      const res = await getCurrentPlanDetail();
      if (res.status !== 200) {
        store.commit("plans/updateInitial", null);
      } else {
        const { plan } = res.data;
        if (!plan.is_default) {
          await store.commit("plans/updatePlan", plan);
        } else {
          await store.commit("plans/updatePlan", plan);
          await store.commit("trial/setIsTrial", true);
          await store.commit("trial/setNextRequest", false);
          await store.commit("trial/setTrialExpiration", 0);
          await store.commit("trial/setEndTimeTrial", 0);
        }

        if (plan && plan.is_trial) {
          await store.commit("trial/setIsTrial", plan.is_trial);
          await store.commit("trial/setTrialId", plan.trial_id);

          const resTrial = await getCurrentTimeTrial(plan.trial_id);
          if (resTrial.status === 200) {
            const trial = resTrial.data;
            const endTimeTrial = trial.endTimeTrial;
            const trialExpiration = trial.trialExpiration;

            await store.commit("trial/setTrialExpiration", trialExpiration);
            await store.commit("trial/setEndTimeTrial", endTimeTrial);
            await store.commit("trial/setNextRequest", trialExpiration > 0);
          }
        }
      }
    }

    const plan = store.state.plans.plan;
    if (!plan || plan.is_default || plan.is_expired) {
      return next({ name: "PaymentHistory" });
    }

    return next();
  } catch (err) {
    console.error("trialPeriod error:", err);
    return next({ name: "Home" });
  }
}

export async function checkOrgStatus(to, from, next) {
  console.log("Checking organization status...");
  if (!store.state.user.userInfo) {
    const res = await getUserLoggedApi(true);
    if (res.status === 200) {
      store.commit("user/updateUser", res.data);
    }

    if (
      res.data.organization.status === ORG_STATUS.CANCEL ||
      (res.data.organization.status === ORG_STATUS.INACTIVE &&
      res.data.organization.service_stop_at &&
      res.data.organization.service_stop_at !== null)
    ) {
      const allowedPages = [
        "PaymentHistory",
        "PaymentAddCard",
        "PaymentDetail",
        "NewCirclePayment",
      ]; // name của các route được phép
      if (!allowedPages.includes(to.name)) {
        return next({ name: "Home" });
      }
    }
  } else {
    if (
      store.state.user.userInfo.organization.status === ORG_STATUS.CANCEL ||
      (store.state.user.userInfo.organization.status === ORG_STATUS.INACTIVE &&
      store.state.user.userInfo.organization.service_stop_at &&
      store.state.user.userInfo.organization.service_stop_at !== null)
    ) {
      const allowedPages = [
        "PaymentHistory",
        "PaymentAddCard",
        "PaymentDetail",
        "NewCirclePayment",
      ];

      if (!allowedPages.includes(to.name)) {
        return next({ name: "Home" });
      }
    }
  }
}

export async function checkFunction(to, from, next) {
  if (!store.state.user.userInfo) {
    const res = await getUserLoggedApi(true);
    if (res.status === 200) {
      store.commit("user/updateUser", res.data);
    }
  } else {
    // console.log("Checking functions: ", to.meta.functions);
    if (!router.app.$can || !checkPermissionPlanFunction(to.meta.functions)) {
      next(from);
      return false;
    }
    next();
  }
}

// export async function organizationTrial(to, from, next) {
//   if (!store.state.plans.initial) {
//     store.commit(
//       "plans/updateInitial",
//       getCurrentPlanDetail().then(async (res) => {
//         if (res.status !== 200) {
//           await store.commit("plans/updateInitial", null);
//           return;
//         }
//         await store.commit("plans/updatePlan", res.data.plan);
//         const is_trial = res.data.plan.is_trial;
//         store.commit("trial/setIsTrial", is_trial);

//         if (res.data.plan.is_default) {
//           await store.commit("trial/setIsTrial", true);
//           await store.commit("trial/setNextRequest", false);
//           await store.commit("trial/setTrialExpiration", 0);
//           await store.commit("trial/setEndTimeTrial", 0);
//         }
//       })
//     );
//   }
//   Promise.resolve(store.state.plans.initial).then(() => {
//     if (
//       !store.state.plans.plan ||
//       store.state.plans.plan.is_default ||
//       store.state.plans.plan.is_expired
//     ) {
//       if (to.name !== "PlanChange") {
//         next({ name: "PlanChange" });
//       }
//     } else if (store.state.trial.isTrial) {
//       next({ name: "Home" });
//     } else {
//       next();
//     }
//   });
// }

export async function organizationTrial(to, from, next) {
  try {
    // ✅ 1. Chỉ load dữ liệu plan nếu chưa có
    if (!store.state.plans.initial) {
      const res = await getCurrentPlanDetail();

      if (res.status !== 200 || !res.data?.plan) {
        store.commit("plans/updateInitial", null);
      } else {
        const plan = res.data.plan;
        store.commit("plans/updatePlan", plan);
        store.commit("plans/updateInitial", true);

        if (plan.is_default) {
          // Đây là plan mặc định → trial mode
          store.commit("trial/setIsTrial", true);
          store.commit("trial/setNextRequest", false);
          store.commit("trial/setTrialExpiration", 0);
          store.commit("trial/setEndTimeTrial", 0);
        } else {
          store.commit("trial/setIsTrial", plan.is_trial);
        }
      }
    }

    const plan = store.state.plans.plan;

    // ⛔ 2. Nếu không có plan hoặc plan đã hết hạn
    if (!plan || plan.is_default || plan.is_expired) {
      if (to.name !== "PlanChange") {
        return next({ name: "PlanChange" });
      }
      return next(); // cho phép ở PlanChange
    }

    // ⛔ 3. Nếu đang trial, chỉ cho phép vào Home
    if (
      store.state.trial.isTrial &&
      to.name !== "Home" &&
      to.name !== "PlanChange"
    ) {
      // Gọi lại API để đảm bảo trạng thái trial mới nhất
      const res = await getCurrentPlanDetail();

      if (res.status === 200 && res.data?.plan?.is_trial) {
        const plan = res.data.plan;
        store.commit("trial/setIsTrial", plan.is_trial);
        store.commit("trial/setTrialId", plan.trial_id);

        // Lấy chi tiết thời gian trial
        const resTrial = await getCurrentTimeTrial(plan.trial_id);
        if (resTrial.status === 200 && resTrial.data) {
          const trial = resTrial.data;
          const endTimeTrial = trial.endTimeTrial;
          const trialExpiration = trial.trialExpiration;

          store.commit("trial/setTrialExpiration", trialExpiration);
          store.commit("trial/setEndTimeTrial", endTimeTrial);
          store.commit("trial/setNextRequest", trialExpiration > 0);
        }
      }

      // ✅ Tránh redirect loop nếu đã ở Home
      if (to.name !== "Home") {
        return next({ name: "Home" });
      }
    }

    // ✅ 4. Nếu mọi điều kiện hợp lệ → cho phép truy cập
    return next();
  } catch (err) {
    console.error("organizationTrial error:", err);
    return next({ name: "Home" });
  }
}
